const React = require("react")
const { AutomaticDebit } = require("./icons/automatic-debit")
const { ExpiryDate } = require("./icons/expiry-date")
const { ReceivingType } = require("./icons/receiving-type")
const { FebrabanAccount } = require("./icons/febraban-account")

module.exports = {
  AutomaticDebit: (props) => (
    <AutomaticDebit alt="Débito automático" {...props} />
  ),
  ExpiryDate: (props) => <ExpiryDate alt="Data de vencimento" {...props} />,
  ReceivingType: (props) => <ReceivingType alt="Envio da fatura" {...props} />,
  FebrabanAccount: (props) => (
    <FebrabanAccount alt="Conta FEBRABAN" {...props} />
  )
}



// WEBPACK FOOTER //
// ./src/shared/skin/icons/iconlink/index.js